import script from "./Kaihu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kaihu.vue?vue&type=script&setup=true&lang=ts"

import "./Kaihu.vue?vue&type=style&index=0&id=392e6b08&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392e6b08"]])

export default __exports__